import * as Sentry from '@sentry/react';

const SENTRY_DSN = import.meta.env.VITE_APP_SENTRY_DSN;
const API_URL = import.meta.env.VITE_APP_API_URL;
const CLIENT_URL = window.location.origin;
const SENTRY_ENVIRONMENT = import.meta.env.VITE_APP_SENTRY_ENVIRONMENT || import.meta.env.MODE;
const localDev = Boolean(API_URL.includes('localhost'));
if (SENTRY_ENVIRONMENT && !localDev) {
  Sentry.init({
    dsn:
      SENTRY_DSN ||
      'https://c6d21c2a513a4eda922ea1096c389052@o4510429764845568.ingest.us.sentry.io/4510434403287040',
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 1,
    // ...
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps
    environment: SENTRY_ENVIRONMENT || 'development',
    // This sets the sample rate to be 33%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 1.0,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    sendDefaultPii: true,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
        networkDetailAllowUrls: [API_URL, CLIENT_URL],
      }),
      Sentry.browserProfilingIntegration(),
      Sentry.browserTracingIntegration(),
    ],
    tracePropagationTargets: [API_URL, '*'],
  });
  console.log('Sentry enabled -', SENTRY_ENVIRONMENT);
}
